// LAVA Perfumes - theme.js

function openCart(){var o=document.getElementById('cart-overlay');if(o)o.classList.add('open');}
function closeCart(){var o=document.getElementById('cart-overlay');if(o)o.classList.remove('open');}

function showToast(msg){
  var t=document.getElementById('toast');
  if(!t)return;
  t.textContent=msg;
  t.classList.add('on');
  setTimeout(function(){t.classList.remove('on');},2800);
}

function lavaMoney(cents){
  return 'EGP '+(cents/100).toLocaleString('en-EG',{minimumFractionDigits:2,maximumFractionDigits:2});
}

function cartItemHTML(item){
  var imgSrc=item.image?(item.image.indexOf('//')==0?'https:'+item.image:item.image):'';
  var k=item.key;
  var h='<div style="display:flex;gap:14px;padding:16px 0;border-bottom:1px solid #f0f0f0">';
  if(imgSrc)h+='<img src="'+imgSrc+'" style="width:70px;height:80px;object-fit:cover;border-radius:6px;border:1px solid #eee" loading="lazy">';
  else h+='<div style="width:70px;height:80px;background:#f5f5f5;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:.7rem;color:#aaa">LAVA</div>';
  h+='<div style="flex:1;min-width:0">';
  h+='<div style="font-size:.82rem;font-weight:600;color:#111;margin-bottom:3px">'+item.product_title+'</div>';
  if(item.variant_title&&item.variant_title!=='Default Title')h+='<div style="font-size:.72rem;color:#aaa;margin-bottom:6px">'+item.variant_title+'</div>';
  h+='<div style="font-size:.82rem;font-weight:700;margin-bottom:8px">'+lavaMoney(item.final_price)+'</div>';
  h+='<div style="display:flex;align-items:center;justify-content:space-between;gap:8px">';
  h+='<div style="display:inline-flex;align-items:center;border:1px solid #ddd;border-radius:30px;overflow:hidden">';
  h+='<button type="button" onclick="cartChange(\''+k+'\','+(item.quantity-1)+')" style="border:none;background:#fff;width:30px;height:30px;cursor:pointer;font-size:16px;color:#111">&minus;</button>';
  h+='<span style="min-width:26px;text-align:center;font-size:.8rem;font-weight:600">'+item.quantity+'</span>';
  h+='<button type="button" onclick="cartChange(\''+k+'\','+(item.quantity+1)+')" style="border:none;background:#fff;width:30px;height:30px;cursor:pointer;font-size:16px;color:#111">+</button>';
  h+='</div>';
  h+='<button type="button" onclick="cartChange(\''+k+'\',0)" style="border:none;background:none;cursor:pointer;font-size:.7rem;letter-spacing:.05em;text-transform:uppercase;color:#b94a4a;text-decoration:underline">Remove</button>';
  h+='</div></div></div>';
  return h;
}

function updateCartDrawer(cart){
  var countEls=document.querySelectorAll('#cart-count-d,.hdr-cart-badge');
  countEls.forEach(function(el){
    el.textContent=cart.item_count;
    el.style.display=cart.item_count>0?'flex':'none';
  });
  var body=document.getElementById('cart-body');
  if(!body)return;
  if(cart.item_count===0){
    body.innerHTML='<div class="cart-empty">Your cart is empty</div>';
    var t0=document.querySelector('.cart-total span:last-child');
    if(t0)t0.textContent=lavaMoney(0);
    return;
  }
  var html='';
  cart.items.forEach(function(item){html+=cartItemHTML(item);});
  body.innerHTML=html;
  var tot=document.querySelector('.cart-total span:last-child');
  if(tot)tot.textContent=lavaMoney(cart.total_price);
}

function cartChange(key,qty){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:key,quantity:qty})})
  .then(function(r){return r.json();})
  .then(function(cart){updateCartDrawer(cart);})
  .catch(function(){showToast('Could not update cart');});
}

document.addEventListener('DOMContentLoaded',function(){
  var form=document.getElementById('product-form');
  if(!form)return;
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=form.querySelector('[type="submit"]');
    var origText=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='Adding...';}
    var fd=new FormData(form);
    fetch('/cart/add.js',{method:'POST',body:fd,headers:{'X-Requested-With':'XMLHttpRequest'}})
    .then(function(r){if(!r.ok)return r.json().then(function(d){throw new Error(d.description||'Error');});return r.json();})
    .then(function(){return fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}});})
    .then(function(r){return r.json();})
    .then(function(cart){
      updateCartDrawer(cart);
      openCart();
      showToast('Added to cart!');
      if(btn){btn.disabled=false;btn.textContent=origText;}
    })
    .catch(function(err){
      showToast(err.message||'Could not add to cart');
      if(btn){btn.disabled=false;btn.textContent=origText;}
    });
  });
});

// Predictive search
document.addEventListener('DOMContentLoaded',function(){
  var input=document.getElementById('hdr-search-input');
  var box=document.getElementById('hdr-search-results');
  var cats=document.getElementById('hdr-search-cats');
  if(!input||!box)return;
  var timer;
  input.addEventListener('input',function(){
    clearTimeout(timer);
    var q=this.value.trim();
    if(q.length<1){box.innerHTML='';if(cats)cats.style.display='';return;}
    if(cats)cats.style.display='none';
    box.innerHTML='<div class="ps-loading">Searching...</div>';
    timer=setTimeout(function(){runSearch(q);},170);
  });
  function fmtPrice(v){if(v==null||v==='')return '';var n=parseFloat(String(v).replace(/[^0-9.]/g,''));if(isNaN(n))return '';return 'EGP '+Math.round(n).toLocaleString('en-EG');}
  function runSearch(q){
    var url='/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url,{headers:{'X-Requested-With':'XMLHttpRequest'}})
    .then(function(r){return r.json();})
    .then(function(d){
      var rs=d.resources&&d.resources.results?d.resources.results:{};
      var prods=rs.products||[];var colls=rs.collections||[];
      var html='';
      if(colls.length){
        html+='<div class="ps-sec-t">Categories</div><div class="ps-colls">';
        colls.forEach(function(c){html+='<a href="'+c.url+'" class="ps-chip">'+c.title+'</a>';});
        html+='</div>';
      }
      if(prods.length){
        html+='<div class="ps-sec-t">Products</div>';
        prods.forEach(function(p){
          var img=(p.image||(p.featured_image&&p.featured_image.url)||'');
          var sub=fmtPrice(p.price)||(p.vendor||'');
          html+='<a href="'+p.url+'" class="ps-item">';
          if(img)html+='<img src="'+img+'" loading="lazy">';
          else html+='<span class="ps-noimg">LAVA</span>';
          html+='<span class="ps-info"><span class="ps-name">'+p.title+'</span><span class="ps-price">'+sub+'</span></span></a>';
        });
      }
      if(!prods.length&&!colls.length)html='<div class="ps-loading">No results for “'+q+'”</div>';
      box.innerHTML=html;
    })
    .catch(function(){box.innerHTML='<div class="ps-loading">Search error</div>';});
  }
});

function toggleAcc(prefix,key){
  var allKeys=['him','her','uni'];
  var allCards=allKeys.map(function(k){return document.querySelector('[data-acc="'+prefix+'"][data-key="'+k+'"]');}).filter(Boolean);
  var allPanels=allKeys.map(function(k){return document.getElementById(prefix+'-panel-'+k);}).filter(Boolean);
  var targetPanel=document.getElementById(prefix+'-panel-'+key);
  var targetCard=document.querySelector('[data-acc="'+prefix+'"][data-key="'+key+'"]');
  var isOpen=targetPanel&&targetPanel.classList.contains('open');
  allCards.forEach(function(c){c.classList.remove('active');});
  allPanels.forEach(function(p){p.classList.remove('open');});
  if(!isOpen&&targetPanel&&targetCard){
    targetCard.classList.add('active');
    targetPanel.classList.add('open');
    setTimeout(function(){targetPanel.scrollIntoView({behavior:'smooth',block:'nearest'});},120);
  }
}

window.addEventListener('scroll',function(){
  var btn=document.getElementById('scrollTop');
  if(btn)btn.classList.toggle('vis',window.scrollY>400);
});

document.addEventListener('DOMContentLoaded',function(){
  var hs=document.getElementById('hscroll');
  if(!hs)return;
  var isDown=false,startX,scrollLeft;
  hs.addEventListener('mousedown',function(e){isDown=true;startX=e.pageX-hs.offsetLeft;scrollLeft=hs.scrollLeft;});
  hs.addEventListener('mouseleave',function(){isDown=false;});
  hs.addEventListener('mouseup',function(){isDown=false;});
  hs.addEventListener('mousemove',function(e){if(!isDown)return;e.preventDefault();var x=e.pageX-hs.offsetLeft;hs.scrollLeft=scrollLeft-(x-startX)*1.5;});
});

function startCountdown(targetDate){
  var h=document.getElementById('cd-h'),m=document.getElementById('cd-m'),s=document.getElementById('cd-s');
  function tick(){
    var diff=new Date(targetDate)-new Date();
    if(diff<=0)return;
    var hv=Math.floor(diff/3600000),mv=Math.floor((diff%3600000)/60000),sv=Math.floor((diff%60000)/1000);
    if(h)h.textContent=String(hv).padStart(2,'0');
    if(m)m.textContent=String(mv).padStart(2,'0');
    if(s)s.textContent=String(sv).padStart(2,'0');
  }
  tick();setInterval(tick,1000);
}
var cdTarget=new Date();cdTarget.setHours(23,59,59,0);
startCountdown(cdTarget);
